export default __webpack_public_path__ + "static/banner-abcebf211052e800badef8ec614810a1.png";